import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { EReservationAssetType } from '../ReservationAssetsTypesList';

interface Props {
  current_asset_type: EReservationAssetType;
}

export function ReservationsAssetsTable({ current_asset_type }: Props) {
  const assets_vae = [
    {
      amount_free_resevations_in: 1,
      hash: 'vae_hash_001',
      base_model_type: 'vae_model',
      name: 'vae',
      version: '1.0',
      size_on_disk: 50,
      using_times_last_30_days: 45,
    },
    {
      amount_free_resevations_in: 2,
      hash: 'vae_hash_002',
      base_model_type: 'vae_model',
      name: 'vae',
      version: '1.1',
      size_on_disk: 55,
      using_times_last_30_days: 30,
    },
    {
      amount_free_resevations_in: 0,
      hash: 'vae_hash_003',
      base_model_type: 'vae_model',
      name: 'vae',
      version: '1.2',
      size_on_disk: 60,
      using_times_last_30_days: 15,
    },
    {
      amount_free_resevations_in: 4,
      hash: 'vae_hash_004',
      base_model_type: 'vae_model',
      name: 'vae',
      version: '2.0',
      size_on_disk: 65,
      using_times_last_30_days: 50,
    },
  ];

  const assets_text_encoder = [
    {
      amount_free_resevations_in: 3,
      hash: 'te_hash_001',
      base_model_type: 'text_encoder_model',
      name: 'text_encoder',
      version: '2.0',
      size_on_disk: 120,
      using_times_last_30_days: 88,
    },
    {
      amount_free_resevations_in: 2,
      hash: 'te_hash_002',
      base_model_type: 'text_encoder_model',
      name: 'text_encoder',
      version: '2.1',
      size_on_disk: 125,
      using_times_last_30_days: 60,
    },
    {
      amount_free_resevations_in: 1,
      hash: 'te_hash_003',
      base_model_type: 'text_encoder_model',
      name: 'text_encoder',
      version: '2.2',
      size_on_disk: 130,
      using_times_last_30_days: 40,
    },
    {
      amount_free_resevations_in: 5,
      hash: 'te_hash_004',
      base_model_type: 'text_encoder_model',
      name: 'text_encoder',
      version: '3.0',
      size_on_disk: 140,
      using_times_last_30_days: 100,
    },
  ];

  const assets_unet = [
    {
      amount_free_resevations_in: 0,
      hash: 'unet_hash_001',
      base_model_type: 'unet_model',
      name: 'unet',
      version: '1.5',
      size_on_disk: 200,
      using_times_last_30_days: 150,
    },
    {
      amount_free_resevations_in: 2,
      hash: 'unet_hash_002',
      base_model_type: 'unet_model',
      name: 'unet',
      version: '1.6',
      size_on_disk: 210,
      using_times_last_30_days: 90,
    },
    {
      amount_free_resevations_in: 1,
      hash: 'unet_hash_003',
      base_model_type: 'unet_model',
      name: 'unet',
      version: '1.7',
      size_on_disk: 220,
      using_times_last_30_days: 60,
    },
    {
      amount_free_resevations_in: 4,
      hash: 'unet_hash_004',
      base_model_type: 'unet_model',
      name: 'unet',
      version: '2.0',
      size_on_disk: 230,
      using_times_last_30_days: 200,
    },
  ];

  const assets_controlnet = [
    {
      amount_free_resevations_in: 5,
      hash: 'cn_hash_001',
      base_model_type: 'controlnet_model',
      name: 'controlnet',
      version: '3.1',
      size_on_disk: 300,
      using_times_last_30_days: 12,
    },
    {
      amount_free_resevations_in: 3,
      hash: 'cn_hash_002',
      base_model_type: 'controlnet_model',
      name: 'controlnet',
      version: '3.2',
      size_on_disk: 310,
      using_times_last_30_days: 20,
    },
    {
      amount_free_resevations_in: 1,
      hash: 'cn_hash_003',
      base_model_type: 'controlnet_model',
      name: 'controlnet',
      version: '3.3',
      size_on_disk: 320,
      using_times_last_30_days: 25,
    },
    {
      amount_free_resevations_in: 0,
      hash: 'cn_hash_004',
      base_model_type: 'controlnet_model',
      name: 'controlnet',
      version: '4.0',
      size_on_disk: 330,
      using_times_last_30_days: 8,
    },
  ];

  const assets_bundle = [
    {
      amount_free_resevations_in: 5,
      base_model_type: 'controlnet_model',
      version: '3.1',
      size_on_disk: 300,
      using_times_last_30_days: 12,
    },
    {
      amount_free_resevations_in: 3,
      base_model_type: 'controlnet_model',
      version: '3.2',
      size_on_disk: 310,
      using_times_last_30_days: 20,
    },
    {
      amount_free_resevations_in: 1,
      base_model_type: 'controlnet_model',
      version: '3.3',
      size_on_disk: 320,
      using_times_last_30_days: 25,
    },
    {
      amount_free_resevations_in: 0,
      base_model_type: 'controlnet_model',
      version: '4.0',
      size_on_disk: 330,
      using_times_last_30_days: 8,
    },
  ];
  /*
   * HTML
   */

  function render_header() {
    return (
      <div className="px-2 w-full flex h-[40px] items-center justify-end gap-2 border-b-2 border-dashed border-component-border">
        <div className="w-[50px] overflow-hidden"></div>
        <div className="w-[150px] overflow-hidden">version</div>
        <div className="w-[150px] overflow-hidden">size_on_disk</div>
        <div className="w-[150px] overflow-hidden">using_times_last_30_days</div>
        <div className="w-[150px] overflow-hidden">base_model_type</div>
        <div className="w-[150px] overflow-hidden">amount_free_resevations_in</div>
        <div className="w-[150px] overflow-hidden">hash</div>
      </div>
    );
  }

  function render_rows() {
    switch (current_asset_type) {
      case EReservationAssetType.VAE:
        return assets_vae.map(asset => {
          return render_row(asset);
        });
      case EReservationAssetType.TEXT_ENCODER:
        return assets_text_encoder.map(asset => {
          return render_row(asset);
        });
      case EReservationAssetType.UNET:
        return assets_unet.map(asset => {
          return render_row(asset);
        });
      case EReservationAssetType.CONTROLNET:
        return assets_controlnet.map(asset => {
          return render_row(asset);
        });
    }
  }

  function render_row(row: any) {
    return (
      <div key={row.hash} className="px-2 w-full h-[40px] flex gap-2 items-center justify-start border rounded-lg border-component-border ">
        <div className="w-[50px] overflow-hidden">
          <UI_PRIMITIVE__checkbox checked={false} onCheckedChange={() => {}} disabled={false} />
        </div>
        <div className="w-[150px] overflow-hidden">{row.version}</div>
        <div className="w-[150px] overflow-hidden">{row.size_on_disk}</div>
        <div className="w-[150px] overflow-hidden">{row.using_times_last_30_days}</div>
        <div className="w-[150px] overflow-hidden">{row.base_model_type}</div>
        <div className="w-[150px] overflow-hidden">{row.amount_free_resevations_in}</div>
        <div className="w-[150px] overflow-hidden">{row.hash}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      {render_header()}

      <div className="relative overflow-auto h-full flex flex-col gap-2">{render_rows()}</div>
    </div>
  );
}
